

!function(f,b,e,v,n,t,s){if(f.fbq)return;n=f.fbq=function(){n.callMethod? n.callMethod.apply(n,arguments):n.queue.push(arguments)};
if(!f._fbq)f._fbq=n;n.push=n;n.loaded=!0;n.version='2.0'; n.queue=[];t=b.createElement(e);t.async=!0; t.src=v;s=b.getElementsByTagName(e)[0]; s.parentNode.insertBefore(t,s)}(window, document,'script', 'https://connect.facebook.net/en_US/fbevents.js');

const FACEBOOK_PIXEL_ID = '471463271443046'
const UTM_SOURCE = [
    'Facebook',
    'facebook',
    'FB',
    'fb',
    'ig',
    'facebook.com',
    'Facebook-SiteLink',
    'FB-Evan',
]
function detectFacebookEnvironment() {
    const ua = navigator.userAgent;
    const isFacebookApp = /FBAN|FBAV/i.test(ua);
    const isFacebookBrowser = /FB_IAB/i.test(ua);
    const urlParams = new URLSearchParams(window.location.search);
    const hasFbclid =urlParams.has('fbclid');
    const urlSource = urlParams.has('utm_source');
    const urlUtmFb = urlSource && UTM_SOURCE.indexOf(urlParams.get('utm_source')) > -1;
    const isFacebookReferrer = document.referrer.includes('facebook.com');
    const isInstagramReferrer = document.referrer.includes('instagram.com');
    return isFacebookApp || isFacebookBrowser || hasFbclid || isFacebookReferrer || isInstagramReferrer || urlUtmFb;
}

// Facebook Pixel
function loadFacebookPixelScript() {
    return new Promise((resolve, reject) => {
        if (typeof fbq !== 'undefined') {
            resolve();
            return;
        }
        
        const script = document.createElement('script');
        script.src = 'https://connect.facebook.net/en_US/fbevents.js';
        script.async = true;
        script.defer = true;
        script.onload = resolve;
        script.onerror = reject;
        document.head.appendChild(script);
    });
}
// Tack Function
function trackFacebookEvent(eventName, parameters) {
    if (typeof fbq !== 'undefined') {
        // if(detectFacebookEnvironment()){
            // fbq('track', eventName, parameters);
            console.log(`%c 🫕The Facebook incident has been triggered: ${eventName} ${parameters} 🫕`,"background: #FACC14; color: #423121");
        // }
    } 
    else {
        console.log(`%c 🫕The Facebook incident has been triggered: ${eventName} ${parameters} 🫕`,"background: #FACC14; color: #423121");
        console.warn('Facebook Pixel Not initialized, unable to track events');
    }
}
// Init Function
async function initializeConditionalPixel() {
    // if (!detectFacebookEnvironment()) {
    //     console.log('当前不在Facebook环境，跳过Pixel加载');
    //     return;
    // }
    
    try {
        if(loadFacebookPixelScript){
            // fbq('init', FACEBOOK_PIXEL_ID);
            // fbq('track', 'PageView');
            console.log(`%c init test`,"background: #FACC14; color: #423121");
            console.log(`%c PageView`,"background: #FACC14; color: #423121");
        }
        else{
            
            console.log('Facebook Pixel has been successfully loaded in the Facebook environment:75');
        }
        observeDynamicContent();
        
    } catch (error) {
        console.error('Facebook Pixel Loading failed. Please check the installation:80', error);
    }
}

function trackEvent(eventCategory, eventName, eventValue) {
  // 使用sendBeacon确保数据可靠上报
  if (navigator.sendBeacon) {
    const data = JSON.stringify({
      category: eventCategory,
      name: eventName,
      value: eventValue,
      timestamp: new Date().toISOString()
    });
    
    navigator.sendBeacon('/cart', new Blob([data], {type: 'application/json'}));
  } else {
    // 降级方案
    // fbq('track', eventName, {value: eventValue});
  }
}
// ViewCategory
function trackViewCategory() {
    const categoryInfo = getCategoryInfo();
    if (categoryInfo && typeof fbq !== 'undefined') {
        trackFacebookEvent('ViewCategory', {
            content_name: categoryInfo.name,
            content_category: categoryInfo.category,
            content_ids: categoryInfo.productIds,
            contents: categoryInfo.products,
            currency: window.Shopify.currency.active,
            value: 0
        });
    }
}
// Get Category Info
function getCategoryInfo() {
    const path = window.location.pathname;
    if (path.includes('/collections/')) {
        const collectionName = extractCollectionName(path);
        const products = getCollectionProducts();
        
        return {
            name: collectionName,
            category: 'general', 
            productIds: products.map(p => p.id),
            products: products.map(p => ({
                id: p.id,
                quantity: 1
            }))
        };
    }
    return null;
}
// 从URL中提取分类名称
function extractCollectionName(path) {
    const segments = path.split('/').filter(segment => segment);
    const collectionIndex = segments.indexOf('collections');
    if (collectionIndex !== -1 && segments[collectionIndex + 1]) {
        return decodeURIComponent(segments[collectionIndex + 1].replace(/-/g, ' '));
    }
    return 'Unknown Collection';
}
// 获取分类中的产品信息
function getCollectionProducts() {
    const products = [];
    // 从页面中获取产品卡片信息
    const productCards = document.querySelectorAll('[data-product-id], .product-card, .grid-product');
    productCards.forEach(card => {
        const productId = card.getAttribute('data-product-id') || 
                        card.querySelector('[data-product-id]')?.getAttribute('data-product-id');
        if (productId) {
            products.push({
                id: productId,
                title: card.querySelector('.product-title, .product-name')?.textContent?.trim() || 'Unknown Product'
            });
        }
    });
    return products;
}
function trackViewContentEvent(){
    // 判断是否为产品页面
    const isProductPage = ()=> {
        const path = window.location.pathname;
        return path.includes('/products/') || 
               document.querySelector('[data-product-id]') !== null ||
               document.querySelector('.product-single') !== null;
    }
    // 检测产品页面并跟踪ViewContent事件
    const trackViewContent =()=> {
        // 检查当前页面是否为产品页面
        if (isProductPage()) {
            const productData = getProductData();
            
            if (productData && typeof fbq !== 'undefined') {
                trackFacebookEvent('ViewContent', {
                    content_name: productData.name,
                    content_ids: [productData.id],
                    content_type: 'product',
                    currency: productData.currency || window.Shopify.currency.active,
                    value: productData.price || 0
                });
            }
        }
    }
    // 获取产品数据
    const getProductData =()=>{
        try {
            // 方法1：从结构化数据中获取
            const structuredData = getStructuredData();
            if (structuredData) {
                return structuredData;
            }
            
            // 方法2：从页面元素中提取
            return extractProductFromPage();
        } catch (error) {
            console.error('An error occurred when obtaining product data:198', error);
            return null;
        }
    }

    // 从JSON-LD结构化数据中获取产品信息
    const getStructuredData = ()=> {
        const scriptTags = document.querySelectorAll('script[type="application/ld+json"]');
        
        for (let script of scriptTags) {
            try {
                const data = JSON.parse(script.textContent);
                if (data['@type'] === 'Product') {
                    return {
                        id: data.sku || data.productID || data['@id'] || generateProductId(),
                        name: data.name || document.title,
                        price: parseFloat(data.offers?.price) || 0,
                        currency: data.offers?.priceCurrency || window.Shopify.currency.active,
                        category: data.category || 'general'
                    };
                }
            } catch (e) {
                // 跳过无法解析的JSON
                continue;
            }
        }
        return null;
    }
    
    // 从页面元素中提取产品信息
    const extractProductFromPage=()=> {
        // 获取产品名称
        const productName = document.querySelector('.product-title, .product-name, h1')?.textContent?.trim();
        
        if (!productName) return null;
        
        // 获取产品价格
        const priceElement = document.querySelector('.product-price, .price, [data-price]');
        let price = 0;
        if (priceElement) {
            const priceText = priceElement.textContent?.replace(/[^\d.]/g, '');
            price = parseFloat(priceText) || 0;
        }
        
        // 获取产品ID
        const productId = document.querySelector('[data-product-id]')?.getAttribute('data-product-id') ||
                   document.querySelector('input[name="id"]')?.value ||
                   generateProductId();
        
        return {
            id: productId,
            name: productName,
            price: price,
            currency: window.Shopify.currency.active,
            category: 'product'
        };
    }
    
    // 生成唯一产品ID（备用方案）
    const generateProductId=()=>{
        return 'shopify_product_' + Math.random().toString(36).substr(2, 9);
    }
    
    // 监听URL变化（针对AJAX导航）
    // let lastUrl = window.location.href;
    // const observer = new MutationObserver(() => {
    //     const currentUrl = window.location.href;
    //     if (currentUrl !== lastUrl) {
    //         lastUrl = currentUrl;
    //         setTimeout(trackViewContent, 1000);
    //     }
    // });
    
    // observer.observe(document, {
    //     subtree: true,
    //     childList: true
    // });
    
    // 初始跟踪
    setTimeout(trackViewContent, 800);
    
    // 错误处理和重试机制
    if (typeof fbq === 'undefined') {
        console.warn('Facebook Pixel Not loaded. It will be tried again in 2 seconds:281');
        
        let retryCount = 0;
        const maxRetries = 5;
        
        const retryInterval = setInterval(() => {
            if (typeof fbq !== 'undefined') {
                clearInterval(retryInterval);
                trackViewContent();
            } else if (retryCount >= maxRetries) {
                clearInterval(retryInterval);
                console.error('Facebook Pixel Loading failed. Please check the installation:292');
            }
            retryCount++;
        }, 2000);
    }
}
// 监听动态内容变化
function observeDynamicContent() {
    document.addEventListener('DOMContentLoaded', function() {
        // Search
        const searchForms = document.querySelectorAll('form[action*="/search"]');
        searchForms.forEach(form => {
            form.addEventListener('submit', function(e) {
                // Get Keywords
                const searchInput = this.querySelector('input[type="search"], input[name="q"]');
                if (searchInput && searchInput.value.trim()) {
                    const searchQuery = searchInput.value.trim();
                    // Tack Facebook Pixel
                    trackFacebookEvent('Search', {
                        search_string: searchQuery,
                        currency: window.Shopify.currency.active,
                        value: 0
                    });

                }
            });
        });
        // 监听URL变化（针对AJAX搜索）
        if (window.location.pathname.includes('/search') && window.location.search.includes('q=')) {
            setTimeout(() => {
                const urlParams = new URLSearchParams(window.location.search);
                const searchQuery = urlParams.get('q');
                if (searchQuery && typeof fbq !== 'undefined') {
                    trackFacebookEvent('Search', {
                        search_string: searchQuery,
                        currency: window.Shopify.currency.active,
                        value: 0
                    });
                }
            }, 1000);
        }
    });
    // 监听页面变化（针对AJAX导航）
    let lastUrl = window.location.href;
    new MutationObserver(() => {
        const currentUrl = window.location.href;
        if (currentUrl !== lastUrl) {
            lastUrl = currentUrl;
            setTimeout(trackViewCategory, 1000);
        }
    }).observe(document, { subtree: true, childList: true });
    // 初始跟踪
    setTimeout(trackViewCategory, 500);
    // 备用方案：监听分类页面加载
    if (window.location.pathname.includes('/collections/')) {
        // 等待产品加载完成
        const observer = new MutationObserver((mutations) => {
            const hasProducts = document.querySelectorAll('[data-product-id]').length > 0;
            if (hasProducts) {
                trackViewCategory();
                observer.disconnect();
            }
        });
        observer.observe(document.body, {
            childList: true,
            subtree: true
        });
        
        // 超时保护
        setTimeout(() => {
            observer.disconnect();
            trackViewCategory();
        }, 3000);
    }
    if (window.location.pathname.includes('/products')) {
        trackViewContentEvent();
    }
}


// 页面加载后执行
if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initializeConditionalPixel);
} else {
    initializeConditionalPixel();
}

// 暴露给全局
window.initializeConditionalPixel = initializeConditionalPixel;